@if (checkInsSummary()) {
  <div class="check-ins-summary">
    <lib-check-ins-summary-survey-list [checkInsSummary]="checkInsSummary()"
                                       (onCheckInSelected)="openCheckInsModal($event)"
    >
    </lib-check-ins-summary-survey-list>
  </div>
}
